var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.hits.length)?_c('div',{class:_vm.isCardUi ? 'flex flex-wrap' : ''},_vm._l((_vm.hits),function(hit){return _c('hit',{key:hit.id,class:{
        '2xl:w-1/3 2xl:border-b-0': _vm.isWide && _vm.isCardUi,
      },attrs:{"hit":hit,"is-wide":_vm.isWide}})}),1):_c('no-results',{attrs:{"has-refinements":_vm.hasRefinements,"message":_vm.noResultsMessage}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }